export const ENABLE_CHECKOUT_EXPRESS_PAYPAL_FF =
    'checkout_enable_express_paypal';

export const POST_CHECKOUT_MANDATORY_QUESTIONS_ORGANIZATIONS_EXCLUSIONS_FF =
    'post-checkout-mandatory-questions-organizations-exclusions';

export const GROUP_WAIVER_QUESTIONS = 'checkout_group_waiver_questions';

export const ASK_REQUIRED_NON_WAIVER_QUESTIONS_AFTER_PAYMENT =
    'checkout_ask_required_non_waiver_questions_after_payment';

export const ENABLE_CAPTCHA_V3_ON_CHECKOUT = 'checkout_enable_recaptcha_v3';

export const ENABLE_GOOGLE_PAY_ON_CHECKOUT = 'checkout_enable_google_pay';

export const ENABLE_MY_TICKETS_URL = 'checkout_enable_mytickets_url'; // TODO: EB-311051 Remove split and use only /mytickets URL
export const TURN_ON_SET_PAYMENT_METHOD_BFF = 'turn_on_set_payment_method_bff';
